

// export enum CouponStatusAprovedRejectedAPI {
//     Aprobados = 1,
//     Rechazados = 2,
//     AprobadosYRechazados = -1,
// }


// export enum CouponStatusCouponHistoryAPI {
//     Pendientes = 0,
//     Aprobados = 1,
//     Rechazados = 2,
//     Utilizados = 2,
//     Todos = -1,
//     TodosMenosPendientes = -2,
// }

export enum CouponStatus {
    Pendientes = 0,
    Aprobados = 1,
    Rechazados = 2,
    Utilizados = 3,
    Todos = -1,
    TodosMenosPendientes = -2,
    UsadosYRechazados = -3,
    PendientesYAprobados = -4,
}

export enum CouponTypes {
    Todo = 0,
    SoloSunat = -1,
    TodoMenosSunat = -2,
}